

import { useDispatch, useSelector } from 'react-redux';
import { Controller } from 'react-hook-form';
import { useState } from 'react'

import { getFormErrorMessage } from '../../../config/global';
import { DISPLAY_OPTIONS, POSITION_OPTIONS } from '../../../Constants/apps';
import { setRssSettings } from '../../../redux/Slices/Apps/appsSlice';
import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import Sketch from '@uiw/react-color-sketch';
import { useTranslation } from 'react-i18next';





const TitleInput = ({ control, errors }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()

    return (
        <div className={`mb-2 col-12`}>
            <label htmlFor="title" className={`mb-0 form-label text-capitalize`} >{t('weather.panel_title')}</label>
            <Controller name="title" control={control}
                rules={{ required: t('weather.title_required') }}
                render={({ field, fieldState }) => (
                    <InputText
                        id={field.name}
                        {...field}
                        onChange={(e) => {
                            field.onChange(e.target.value);
                            // dispatch(setRssSettings({ title: e.target.value }))
                        }}
                        inputRef={field.ref}
                        className={`w-100  ${classNames({ 'p-invalid': fieldState.invalid })}`}
                    />
                )} />
            {getFormErrorMessage("title", errors)}
        </div>
    )
}

export { TitleInput }